import { useState } from "react";

const BranchAtmTable = ({ userData }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [expandedBranches, setExpandedBranches] = useState({});

  if (!userData?.restrictedUser || !userData?.branchDetails?.length) {
    return null;
  }

  // Filter branches
  const filteredBranches =
    searchTerm.trim() === ""
      ? userData.branchDetails
      : userData.branchDetails.filter(
          (branch) =>
            branch.branchName
              .toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            branch.region.toLowerCase().includes(searchTerm.toLowerCase()) ||
            branch.devices?.some((device) =>
              device.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );

  // Sort branches
  const sortedBranch = () => {
    if (!sortConfig.key) return filteredBranches;

    return [...filteredBranches].sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];

      if (aValue < bValue) {
        return sortConfig.direction === "asc" ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === "asc" ? 1 : -1;
      }
      return 0;
    });
  };
  const sortedBranches = sortedBranch();

  // Handlers
  const handleSort = (key) => {
    setSortConfig((current) => ({
      key,
      direction:
        current.key === key && current.direction === "asc" ? "desc" : "asc",
    }));
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const toggleExpand = (branchId) => {
    setExpandedBranches((prev) => ({
      ...prev,
      [branchId]: !prev[branchId],
    }));
  };

  // Render ATMs inside branch table
  const renderATMs = (branch) => {
    const devices = branch.devices || [];
    if (devices.length === 0) {
      return <span className="no-atms-tag">No ATM assigned</span>;
    }

    const isExpanded = expandedBranches[branch.branchId];
    const visibleATMs = isExpanded ? devices : devices.slice(0, 3);
    const remainingCount = devices.length - 3;

    return (
      <div className="atm-list">
        {visibleATMs.map((device, index) => (
          <span key={index} className="atm-tag" title={device}>
            {device}
          </span>
        ))}
        {remainingCount > 0 && (
          <button
            className="atm-tag more-atms"
            onClick={() => toggleExpand(branch.branchId)}
          >
            {isExpanded ? "Show less" : `+${remainingCount} more`}
          </button>
        )}
        <span
          className="atm-count"
          onClick={() => toggleExpand(branch.branchId)}
        >
          {devices.length} ATMs
        </span>
      </div>
    );
  };

  return (
    <div>
      {/* Branch-wise table */}
      <div className="branch-wise-breakdown">
        <div className="branch-details-header">
          <h3 className="branch-details-title">ATMs by Branch</h3>
          <div className="branch-controls">
            <div className="branch-search">
              <input
                type="text"
                placeholder="Search by Branch, Region or ATM"
                value={searchTerm}
                onChange={handleSearch}
                className="branch-search-input background-primary"
              />
              <i className="fa fa-search branch-search-icon" />
            </div>
          </div>
        </div>

        {sortedBranches.length > 0 ? (
          <>
            <div className="branch-table-container">
              <table className="branch-table">
                <thead className="background-primary">
                  <tr>
                    <th
                      className="sortable"
                      onClick={() => handleSort("branchName")}
                    >
                      Branch Name
                      {sortConfig.key === "branchName" &&
                        (sortConfig.direction === "asc" ? " ↑" : " ↓")}
                    </th>
                    <th
                      className="sortable"
                      onClick={() => handleSort("region")}
                    >
                      Region
                      {sortConfig.key === "region" &&
                        (sortConfig.direction === "asc" ? " ↑" : " ↓")}
                    </th>
                    <th>ATMs</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedBranches.map((branch, index) => (
                    <tr key={branch.branchId || index}>
                      <td className="branch-name-cell">{branch.branchName}</td>
                      <td className="branch-region-cell">{branch.region}</td>
                      <td className="branch-atms-cell">{renderATMs(branch)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <div className="branch-empty-state">
            <div className="branch-empty-icon">🔍</div>
            <p>No branches found matching your search criteria.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BranchAtmTable;
